// « Ce que Shopify envoie vraiment » + the old website engine's switch-off plan
// (owner, 2026-10-15, sketch board « Shopify / site »). Read-only numbers.
import { useQuery } from '@tanstack/react-query';
import { useT } from '@/lib/i18n';
import { processApi } from '@/lib/processApi';

const FIELD_FR: Record<string, string> = {
  name: 'Nom', phone: 'Téléphone', pack: 'Pack (Solo / Duo / Trio)', title: 'Titre de l’album',
  payment_method: 'Mode de paiement', address: 'Adresse + ville', city: 'Ville (champ à part)', email: 'E-mail',
};

export function SiteFieldsCard() {
  const { t } = useT();
  const { data, isLoading, isError } = useQuery({ queryKey: ['process-site-fields'], queryFn: () => processApi.siteFields(), staleTime: 300_000 });
  return (
    <div className="flex flex-col gap-4">
      <section aria-labelledby="site-fields-h" className="bg-white border border-gray-200 rounded-2xl p-5">
        <h2 id="site-fields-h" className="text-[20px] font-semibold text-gray-900" style={{ fontFamily: "'Fraunces', Georgia, serif" }}>{t('Ce que Shopify nous envoie vraiment')}</h2>
        <p className="text-[12.5px] text-gray-600 mt-1">
          {isLoading ? t('Lecture…') : isError || !data ? t('Lecture impossible pour l’instant.') : t('{n} commandes du site, 60 derniers jours (lu sans rien modifier).', { n: data.orders })}
        </p>
        {data && (
          <table className="w-full mt-3 text-[13px]">
            <thead>
              <tr className="text-left text-gray-500">
                <th scope="col" className="py-1.5 pr-2 font-semibold border-b border-gray-100">{t('Information')}</th>
                <th scope="col" className="py-1.5 pr-2 font-semibold border-b border-gray-100 w-24">{t('Remplie')}</th>
                <th scope="col" className="py-1.5 font-semibold border-b border-gray-100">{t('Donc l’étape…')}</th>
              </tr>
            </thead>
            <tbody>
              {data.fields.map((f) => (
                <tr key={f.field}>
                  <td className="py-1.5 pr-2 border-b border-gray-50 font-semibold text-gray-900">{t(FIELD_FR[f.field] ?? f.field)}</td>
                  <td className={`py-1.5 pr-2 border-b border-gray-50 font-bold tabular-nums ${f.pct >= 95 ? 'text-emerald-800' : f.pct <= 5 ? 'text-red-800' : 'text-amber-800'}`}>{f.pct} %</td>
                  <td className="py-1.5 border-b border-gray-50 text-gray-700">
                    {f.how === 'note' ? t('texte libre dans la note : demander rue + quartier une fois')
                      : f.pct >= 95 ? t('sautée') : f.pct <= 5 ? t('jamais envoyé — demandé sur WhatsApp') : t('parfois — sautée quand présente')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
      <section aria-labelledby="old-engine-h" className="bg-white border border-gray-200 rounded-2xl p-5">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <h2 id="old-engine-h" className="text-[20px] font-semibold text-gray-900" style={{ fontFamily: "'Fraunces', Georgia, serif" }}>{t('Ancien moteur des commandes du site')}</h2>
          <span className="text-[11.5px] font-bold px-2.5 py-1 rounded-full bg-red-50 text-red-800">{t('tourne en double aujourd’hui')}</span>
        </div>
        <p className="text-[12.5px] text-gray-600 mt-1">{t('Cet onglet le remplace. Il n’est pas supprimé : mis en sommeil, il revient d’un clic.')}</p>
        <ol className="list-decimal pl-5 mt-2 text-[13px] leading-relaxed text-gray-800">
          <li>{t('Nouvel interrupteur « Ancien moteur » (ON au départ) — rien ne change tant que vous ne le coupez pas.')}</li>
          <li>{t('Coupé : plus de nouveau parcours, mais le lien commande ↔ conversation est toujours enregistré.')}</li>
          <li>{t('Les parcours en cours sont mis en pause (avec votre OK), jamais effacés.')}</li>
          <li>{t('Ses messages sont repris par cet onglet ; un trou à confirmer : l’accusé « Photos bien reçues ».')}</li>
          <li>{t('7 jours de contrôle : aucun nouveau parcours, chaque commande du site a sa conversation.')}</li>
          <li>{t('Retour arrière : rallumer l’interrupteur.')}</li>
        </ol>
      </section>
    </div>
  );
}
